export abstract class BaseValidator {
    constructor() {}
    public abstract validate(val: any, inputParams?: any): any;
    public abstract getValidatorConfig(): any
    public abstract getDetails(): any
}